import React from 'react'

import { params } from '../../../../redux/reducers/reducer';

import FrontStorage from './FrontStorage';
import BackStorage from './BackStorage';
import LeftStorage from './LeftStorage';
import RightStorage from './RightStorage';

const Storage = () => {
    return (
        <>
            {!params.nostorage && params.cB_addStorage_check_front && <FrontStorage />}
            {!params.nostorage && params.p_u_c && <BackStorage />}
            {!params.nostorage && params.cB_addStorage_check_left && <LeftStorage />}
            {!params.nostorage && params.cB_addStorage_check_right && <RightStorage />}
        </>
    )
}

export default Storage